import { configureStore } from '@reduxjs/toolkit';
import { createLogger } from 'redux-logger';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import RootReducer from 'Store/Reducers/RootReducer';

const logger = createLogger({
  collapsed: true,
});

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['masterData'],
  transforms: [
    {
      in: (state) => ({
        ...state,
        _persistedAt: Date.now(),
      }),
      out: (state) => {
        const expirationTime = 10 * 60 * 1000;
        const timeDifference = Date.now() - state._persistedAt;
        return timeDifference > expirationTime ? undefined : state;
      },
    },
  ],
};

const persistedReducer = persistReducer(persistConfig, RootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
      },
      immutableCheck: false,
    }).concat(process.env.NODE_ENV !== 'production' ? [logger] : []),
  devTools: process.env.NODE_ENV !== 'production',
});

const persistor = persistStore(store);

export { store, persistor };
